import React, { Fragment, PureComponent, memo } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Col, Text, FlexView, SectionList, Separator } from '@cuemath/comps';

import Link from 'comps/link';
import { InfoIcon, ChapterIcon } from 'comps/icon';
import { openModal } from 'actions/modal';
import { HighlightedRow } from 'comps/styled-row';
import { PointerText as ChapterText, CenterText as HeaderText } from 'comps/styled-text';
import MODAL from 'constants/modal';
import COLORS from 'constants/colors';

const ChapterSection = connect(
  null,
  dispatch => ({
    actions: bindActionCreators({ openModal }, dispatch),
  }),
)(
  memo(({ actions, chapter, selected }) => {
    const onChapterIconClick = () => {
      actions.openModal(
        'table',
        {
          size: 'custom',
          width: MODAL.WIDTH,
          height: MODAL.HEIGHT,
        },
        {
          tableData: chapter,
          title: `Chapter: ${chapter.code}`,
          tableKeys: ['id', 'code', 'name', 'description', 'is_active', 'is_default'],
          keyName: {
            is_active: 'Is Active',
            is_default: 'Is Default',
          },
        },
      );
    };
    return (
      <HighlightedRow
        backgroundColor={selected ? COLORS.HIGHLIGHT : 'clear'}
        alignItems="center"
        gap={4}
        gutter
      >
        <Col>
          <ChapterIcon size={14} />
        </Col>
        <Col gutter={4}>
          <ChapterText>
            {chapter.name} ({chapter.code})
          </ChapterText>
        </Col>
        <Col autoRight>
          <InfoIcon size={14} onClick={onChapterIconClick} />
        </Col>
      </HighlightedRow>
    );
  }),
);

export default class Chapter extends PureComponent {
  static propTypes = {
    chapters: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
    programCode: PropTypes.string.isRequired,
    match: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  };

  versionIdExtractor = chapterVersion => chapterVersion.id;

  chapterIdExtractor = chapter => chapter.id;

  isCurrentChapterSelected = (chapterVersionId, versions) => {
    if (!chapterVersionId) return false;

    for (const index in versions) {
      if (chapterVersionId === versions[index].id) {
        return true;
      }
    }
    return false;
  };

  renderSectionHeader = section => {
    const { versions } = section;
    const { match } = this.props;
    return (
      <ChapterSection
        chapter={section}
        selected={this.isCurrentChapterSelected(match.params.versionId, versions)}
      />
    );
  };

  renderSectionFooter = () => <Separator />;

  renderItem = ({ item: version, section }) => {
    const { programCode, match } = this.props;
    const selectedVersionId = match.params.versionId;

    return (
      <Fragment>
        <HighlightedRow
          backgroundColor={
            selectedVersionId && selectedVersionId === version.id
              ? COLORS.HIGHLIGHT
              : 'clear'
          }
          gutter={64}
        >
          <Col>
            <Link to={`/curriculum/${programCode}/chapter-contents/${version.id}/`}>
              <Text type={version.is_live ? 'light' : 'normal'}>
                {' '}
                Version: {version.version}{' '}
              </Text>
            </Link>
          </Col>
        </HighlightedRow>
      </Fragment>
    );
  };

  render() {
    const { chapters, match } = this.props;

    return (
      <FlexView>
        <HeaderText> Chapters</HeaderText>
        {chapters.length ? (
          <SectionList
            match={match}
            data={chapters}
            dataKey="versions"
            sectionKeyExtractor={this.chapterIdExtractor}
            itemKeyExtractor={this.versionIdExtractor}
            renderSectionHeader={this.renderSectionHeader}
            renderSectionFooter={this.renderSectionFooter}
            renderItem={this.renderItem}
          />
        ) : (
          <Text align="center"> No Chapters Present</Text>
        )}
      </FlexView>
    );
  }
}
